export interface Benefit {
  title: string
  text: string
}

export const benefits: Benefit[] = [
  {
    title: 'Save time',
    text: 'Stop building every session from scratch. Pick the session and walk into the gym prepared.',
  },
  {
    title: 'Ready to use',
    text: 'Warm-up, drills, rounds, cues and cool-down already laid out. Open the page, teach the session.',
  },
  {
    title: 'Structured sessions',
    text: 'Clear progressions from foundations to tactics, so every class connects to the one before it.',
  },
  {
    title: 'Visual coaching',
    text: 'Technique breakdowns, diagrams and frameworks you can show and explain in seconds.',
  },
  {
    title: 'More training variety',
    text: '150 sessions, 150 bonus drills and 50 games — no more repeating the same handful of exercises.',
  },
  {
    title: 'Coach with confidence',
    text: 'Know what to correct, which cue to use and what should come next for every athlete.',
  },
]
